
import { useState } from "react";
import { Alert, Button, Container, OffcanvasBody, OffcanvasHeader } from "reactstrap";
import styles from "./style.module.scss"
import cx from "classnames";
import DefaultOffCanvas, { DefaultOffCanvasProps } from "../DefaultOffCanvas";
import ErrorsViewer from "./ErrorsViewer";
import RejectionDiagnostic from "./RejectionDiagnostic";
import { DiagnosableModel } from "@/api/EDocumentDiagnosticApi";
import { EDocumentAtvStatus } from "@utils/edocumentAtvStatus";

export type EDocumentStatusProps = {
    status: string,
    message: string
}

// El tipo vive junto al resolver de estado para que utils y componentes compartan
// una sola definicion; se re-exporta aqui porque ya se importaba desde este modulo.
export type { EDocumentAtvStatus } from "@utils/edocumentAtvStatus";

/** Documento al que pertenece el estado, para poder diagnosticar el rechazo. */
export type EDocumentStatusReference = {
    model: DiagnosableModel,
    id: string
}

type EDocumentStatusOffCanvasProps = {
    payload?: EDocumentStatusProps | null,
    documentStatus?: EDocumentAtvStatus,
    documentReference?: EDocumentStatusReference | null
} & DefaultOffCanvasProps

const EDocumentStatusOffCanvas = (props: EDocumentStatusOffCanvasProps) => {
    const { btnColor = "primary", className = "", payload, documentStatus, documentReference } = props;
    const [isOpen, setOpen] = useState(false);

    const toogleOffCanvas = (newState: boolean) => {
        setOpen(newState);
        if (newState == false) {
            onCanvasClosed();
        }
    }

    const onCanvasClosed = () => {
        setOpen(false);
    }

    return (
        <>
            {props.children && (<Button
                data-testid="edocument-status"
                data-status={documentStatus}
                className={cx({
                    [className]: className,
                    [styles.button]: true,
                    [styles.pendiente]: documentStatus === "pendiente",
                    [styles.rechazada]: documentStatus === "rechazado",
                    [styles.aceptada]: documentStatus === "aceptado"
                })}
                type="button"
                onClick={() => toogleOffCanvas(!isOpen)}
            >
                {props.children}
            </Button>
            )}
            <DefaultOffCanvas
                className={styles.offCanvas}
                direction="end"
                isOpen={isOpen}
                onClosed={onCanvasClosed}
                toggle={() => toogleOffCanvas(!isOpen)}
            >
                <OffcanvasHeader className={styles.offCanvasHeader} toggle={onCanvasClosed}>
                    Mensaje de respuesta del ATV
                </OffcanvasHeader>
                <OffcanvasBody>
                    <Container>
                        {documentStatus === "pendiente" ?
                            (<Alert className="mb-4" color="warning">
                                Mensaje de respuesta no disponible aun
                            </Alert>) :
                            <ErrorsViewer text={payload?.message ?? ""} documentStatus={documentStatus} />
                        }
                        {/* Solo con el offcanvas abierto: el diagnostico consulta el documento y el catalogo de Hacienda. */}
                        {isOpen && documentStatus === "rechazado" && documentReference && (
                            <RejectionDiagnostic
                                model={documentReference.model}
                                documentId={documentReference.id}
                            />
                        )}
                    </Container>
                </OffcanvasBody>
            </DefaultOffCanvas >
        </>
    );
}
export default EDocumentStatusOffCanvas;
